import { ofType, unionize, UnionOf } from 'src/framework'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { UserMeProfile } from 'src/services/ds.service'

export interface UpdateMyProfile {
  type: 'UpdateMyProfile'
  email: string
  firstName: string
  lastName: string
  token: string
  [startFetch]: string
}

export interface UpdateMyProfileSuccess {
  type: 'UpdateMyProfileSuccess'
  profile: UserMeProfile
  [stopFetch]: string
}

export interface UpdateMyProfileFailure {
  type: 'UpdateMyProfileFailure'
  [stopFetch]: string
}

export interface UpdateMyPassword {
  type: 'UpdateMyPassword'
  oldPassword: string
  newPassword: string
  token: string
  [startFetch]: string
}

export interface UpdateMyPasswordSuccess {
  type: 'UpdateMyPasswordSuccess'
  [stopFetch]: string
}

export interface UpdateMyPasswordFailure {
  type: 'UpdateMyPasswordFailure'
  [stopFetch]: string
}

export interface LoadProfile {
  type: 'LoadProfile'
  token: string
  [startFetch]: string
}

export interface LoadProfileSuccess {
  type: 'LoadProfileSuccess'
  profile: UserMeProfile
  [stopFetch]: string
}

export interface LoadProfileFailed {
  type: 'LoadProfileFailed'
  [stopFetch]: string
}

export const meActions = unionize({
  ...ofType<UpdateMyProfile>('UpdateMyProfile'),
  ...ofType<UpdateMyProfileSuccess>('UpdateMyProfileSuccess'),
  ...ofType<UpdateMyProfileFailure>('UpdateMyProfileFailure'),
  ...ofType<LoadProfile>('LoadProfile'),
  ...ofType<LoadProfileSuccess>('LoadProfileSuccess'),
  ...ofType<LoadProfileFailed>('LoadProfileFailed'),
  ...ofType<UpdateMyPassword>('UpdateMyPassword'),
  ...ofType<UpdateMyPasswordSuccess>('UpdateMyPasswordSuccess'),
  ...ofType<UpdateMyPasswordFailure>('UpdateMyPasswordFailure')
})

export type MeActions = UnionOf<typeof meActions>



// WEBPACK FOOTER //
// ./src/users-components/me/me.actions.ts